import { render, staticRenderFns } from "./WsUpdateDialog.vue?vue&type=template&id=5cab6246&"
import script from "./WsUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./WsUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports